<template>
  <div id="container">
    <div class="col-md-10 col-md-offset-1">
      <div
        class="item-box-content contwent"
        style="position:relative;padding:14px 20px;">
        <div class="title-font-style">
          <span>企业架构配置</span>
        </div>
        <div
          class="right_btn"
          style="position:absolute;top:10px;right:20px;">
          <el-button
            :disabled="updataStroe"
            @click="toupdataStore">更新仓库
          </el-button>
        </div>
      </div>
      <!--  v-show="selectItem&&selectItem.type===0" -->
      <div
        class="text-center"
        v-loading="loading"
        element-loading-text="拼命加载中请稍后..."
        element-loading-spinner="el-icon-loading"
        ref="conent_center"
        style="border-radius: 4px;">
        <div class="top_header">
          <div>
            <el-button
              type="primary"
              @click="addgroup"
              :disabled="creatdepartdisabled"
            >{{isStatusCreateGroupOneEnable?'创建部门':'创建子部门'}}
            </el-button>
            <div
              v-if="isStatusCreateGroupOneEnable==0"
              style="display: inline-block">
              <el-button
                @click="updateroleS"
                v-show="data.children"
                style="margin-left: 10px;">
                修改/添加角色
              </el-button>
              <el-button
                @click="tosendimport"
                v-show="isshow"
                :disabled="storeFalg">导入仓库
              </el-button>
              <el-select
                style="width:80px;margin-left: 10px;"
                class="font_btn"
                v-model="select_value"
                v-show="data.children"
                ref="selecItem"
                placeholder="更多"
                @visible-change="uphandler"
                popper-class="optionsContent"
                :disabled="storeDiaabled"
                @change="handlechange"
              >
                <el-option
                  v-for="item in operation"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                  <span>{{item.label}}</span>
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div
          style="width: 100%;margin-top: 40px;overflow-x: auto;min-height: calc(100vh - 300px);"
          id="tree_box">
          <!--          height: calc(100vh - 300px);overflow: hidden;display: flex;justify-content: center;align-items: center   -->
          <vue2-org-tree
            name="test"
            :data="data"
            id="tree-el"
            style="cursor:pointer;postion:relative"
            :horizontal="horizontal"
            :collapsable="collapsable"
            :label-class-name="addClass"
            :render-content="renderContent"
            @on-node-mouseover="getourse"
            @on-expand="onExpand"
            @on-node-mouseout="outourse"
            @on-node-click="onNodeClick"
          />
        </div>
      </div>
      <!--      创建/编辑部门-->
      <base-dialog
        :title="title"
        :dialogVisible.sync="dialogVisible"
        @successEv="submitCheck"
        @cancelEv="close"
        :succlosedialog="false"
        @closedialogVisibale="departClosedialogVisibale"
      >
        <el-form
          :model="groupex"
          :rules="rules"
          ref="group"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item
            label="部门名称："
            prop="name">
            <el-input
              v-model.trim="groupex.name"
              placeholder="请输入部门名称"></el-input>
          </el-form-item>
        </el-form>
      </base-dialog>
      <!--       修改/新增角色-->
      <base-dialog
        :dialog-visible.sync="roleDialog"
        :title="`修改/新增角色`"
        @successEv="updataroleSucEv"
        @cancelEv="closeRoleDialog"
        :succlosedialog="false"
        @closedialogVisibale="roleClosedialogVisbale"
      >
        <el-form
          label-width="110px"
          :model="group"
          ref="roleFormex"
          :rules="roleRules">
          <el-form-item
            label="角色："
            prop="role">
            <el-select
              v-model="group.role"
              value-key="id"
              placeholder="请选择角色"
              multiple
              @remove-tag="roleRemoveTag"
              @change="changeRoles"
            >
              <el-option
                v-for="(item,i) in options"
                :key="i + 'aa'"
                :label="item.roleName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            prop="grouprole"
            label="部门管理角色：">
            <el-select
              v-model="group.grouprole"
              @change="abc"
              value-key="id"
              placeholder="请选则部门管理角色">
              <el-option
                v-for="(item,index) in optionsGroup"
                :key="index + 'abc'"
                :label="item.roleName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </base-dialog>
      <base-dialog
        :dialog-visible.sync="importStoreFlag"
        @successEv="sucImportStore"
        :succlosedialog="false"
      >
        <template>
          <span
            style="padding:0 0 30px 26px;"
            v-show="!importStoreFail">{{updataStoretxt}}</span>
          <span
            style="padding:0 0 30px 26px;"
            v-show="importStoreFail">{{tiptopTitle}}</span>
        </template>
      </base-dialog>
    </div>
  </div>
</template>
<script>
  import BaseDialog from '@/components/module/baseDialog'
  import {
    getTreegroup,
    updategroupname,
    getAddgroupItem,
    getRoleList,
    getGrouoRole,
    deletGroupInfo,
    imporystorageAll,
    editGroupRole,
    treeAddRole
  } from '../../../api/system/rightsManagement'
  import { isEmpty } from 'loadsh'
  import { isSuccess } from '@/util/tool'
  import { deepClone } from '@/util'
  import { getCurNodeChild, updataStore } from '@/api/system/rightsManagement'

  var _this
  export default {
    components: {
      BaseDialog
    },
    data () {
      return {
        importStoreFlag: false,
        updataStroe: true,
        updataStoretxt: '确认导入所有仓库到仓储部？',
        placeholder: '请输入内容',
        isgroup: true,
        btntitle: '创建部门',
        roleDialog: false,
        importStoreFail: false,
        isStatusCreateGroupOneEnable: 1,
        loading: true,
        dataceshi: {
          children: [
            {
              firstCharge: 1,
              firstChargeName: null,
              flag: true,
              id: 1,
              children: [],
              isAdministration: false,
              mark: '公司名称',
              orgCode: 'COM00001',
              orgFatherId: 1,
              orgFatherPath: '鼎定自动化(上海)有限公司ret',
              orgFatherPathIds: ',1,',
              orgName: '鼎定自动化(上海)有限公司ret',
              orgSerial: 1,
              secondCharge: null,
              secondChargeName: null,
              type: 0
            }
          ],
          firstCharge: 1,
          firstChargeName: null,
          flag: true,
          id: 1,
          isAdministration: false,
          mark: '公司名称',
          orgCode: 'COM00001',
          orgFatherId: 0,
          orgFatherPath: '鼎定自动化(上海)有限公司ret',
          orgFatherPathIds: ',1,',
          orgName: '鼎定自动化(上海)有限公司ret',
          orgSerial: 1,
          secondCharge: null,
          secondChargeName: null,
          type: 0
        },
        isinit: true,
        isPower: false,
        isshow: true,
        creatdepartdisabled: false,
        rules: {
          name: [{
            required: true,
            message: '请输入部门名称',
            trigger: 'blur'
          }],
          grouprole: [
            {
              required: true,
              message: '请选择部门角色',
              trigger: 'blur'
            }
          ]
        },
        roleRules: {
          grouprole: [{
            required: false,
            message: '请选择部门管理角色',
            trigger: 'change'
          }]
        },
        group: {
          role: [],
          grouprole: null
        },
        groupex: {
          name: ''
        },
        istatus: 0,
        dialogVisible: false,
        title: '创建部门',
        select: 0,
        operation: [
          {
            value: '0',
            label: '修改部门'
          },
          {
            value: '1',
            label: '删除部门'
          }
        ],
        select_value: '',
        options: [],
        optionsGroup: [], // 这是部门管理员的

        valueslist: [],
        value: '',
        data: {},
        horizontal: false,
        collapsable: true,
        expandAll: false,
        labelClassName: 'bg-gray',
        selectItem: {},
        fatherItem: {},
        list: [],
        storeFalg: false,
        preflowlever: 3,
        baseScale: 0.3,
        translateX: 0,
        translateY: 0,
        flowlever: 3,
        tiptopTitle: '',
        storeDiaabled: false
      }
    },
    watch: {
      selectItem: {
        deep: true,
        handler: function (newVal, oldVal) {
          if (newVal) {
            this.selectItem = newVal
          }
        }
      },
      'group.role': {
        handler (data) {
          const { options } = this
          this.optionsGroup = []
          if (!data || data.length === 0) return data
          data.forEach(id => {
            const a = options.find(itemex => itemex.id === id)
            const b = this.optionsGroup.find(ex => ex.id === a.id)
            if (a && !b) {
              this.optionsGroup.push(a)
            }
          })
          return Array.from(new Set(data))
        }
      },
      select_value: function (newVal) {
        const { selectItem } = this
        if (isEmpty(selectItem)) {
          this.dialogVisible = false
          return false
        } else {
          // 修改部门
          if (Number(newVal) === 0) {
            this.istatus = 1
            this.title = '修改部门'
            this.select_value = ''
            this.placeholder = selectItem.orgName
          } else {
            if (selectItem.children && selectItem.children.length !== 0) {
              this.$message.error('请把本部门员工转移至其他部门再进行删除！')
              return
            }
            // 删除部门
            deletGroupInfo(selectItem.decorateId).then(res => {
              if (isSuccess(res)) {
                this.$message.success('删除部门成功！')
                this.selectItem = {}
                this.isStatusCreateGroupOneEnable = true
                const index = this.fatherItem.children.findIndex(item => item.decorateId === selectItem.decorateId)
                if (index !== -1) {
                  this.fatherItem.children.splice(index, 1)
                }
                // this.getInit()
              } else {
                this.$message.error(res.data.msg)
              }
            })
          }
        }
      }
    },
    mounted () {
      _this = this
      this.preflowlever = 3
      this.getInit()
      this.getrole()
      document.getElementById('tree-el').onclick = (e) => {
        this.toactive([this.data], '', e)
        this.isStatusCreateGroupOneEnable = true
        this.selectItem = {}
      }
      // document.getElementById('tree_box').onmousewheel = (e) => {
      //   e = e || window.event;
      //   if (e.wheelDelta) {//IE/Opera/Chrome
      //     this.mouseScroll(e.wheelDelta);
      //   } else if (e.detail) {//Firefox
      //     this.mouseScroll(e.detail);
      //   }
      // }
      // document.getElementById('tree_box').onmousedown = (e) =>{
      //   const eClientX = e.clientX
      //   const eClientY = e.clientY
      //   const {translateX,translateY} = this
      //   document.getElementById('tree-el').style.transform = `scale(${this.baseScale}) translate(${translateX}px, ${translateY}px)`
      //   document.onmousemove = (ev) => {
      //     console.log(eClientX - ev.clientX);
      //     this.translateX = translateX-((eClientX - ev.clientX) / this.baseScale)
      //     this.translateY = translateY-((eClientY - ev.clientY) / this.baseScale)
      //     document.getElementById('tree-el').style.transform = `scale(${this.baseScale}) translate(${this.translateX}px, ${this.translateY}px)`
      //   }
      //   document.onmouseup = (ex) => {
      //     document.onmousemove = null
      //   }
      // }
    },
    methods: {
      // mouseScroll(scale){
      //   const {baseScale,translateX,translateY} = this
      //   if(scale > 0){
      //     if(baseScale > 1.5) return
      //     this.baseScale = baseScale + 0.01
      //     document.getElementById('tree-el').style.transform = `scale(${this.baseScale}) translate(${translateX}px, ${translateY}px)`
      //   }else{
      //     if(baseScale <= 0.3) return
      //     this.baseScale = baseScale - 0.01
      //     document.getElementById('tree-el').style.transform = `scale(${this.baseScale}) translate(${translateX}px, ${translateY}px)`
      //   }
      // },
      roleRemoveTag (ids) {
        const { children } = this.selectItem
        const { grouprole } = this.group
        const roles = children.find(item => item.decorateId === ids)
        if (roles.children && roles.children.length) {
          this.$message.error('请先转移该角色下的员工；')
          this.group.role.push(ids)
        }
      },
      abc (a) {
        this.optionsGroup = deepClone(this.optionsGroup)
        this.group.grouprole = a
      },
      changeRoles (data) {
        const { grouprole } = this.group
        const index = data.findIndex(ids => ids === grouprole)
        if (index === -1) {
          this.group.grouprole = null
        }
      },
      sucImportStore () {
        if (this.importStoreFail) {
          this.importStoreFlag = false
          this.importStoreFail = false
          this.tiptopTitle = ''
          return
        }
        imporystorageAll(this.selectItem.decorateId).then(
          res => {
            if (isSuccess(res)) {
              this.$message({
                message: res.data.msg,
                type: 'success'
              })
              this.storeFalg = true
              this.getInit()
              return false
            }
            this.importStoreFail = true
            this.tiptopTitle = res.data.msg
          }
        )
      },
      departClosedialogVisibale () {
        this.$refs.group.resetFields()
      },
      roleClosedialogVisbale () {
        this.$refs.roleFormex.resetFields()
      },
      closeRoleDialog () {
        this.roleDialog = false
        this.group = {
          role: [],
          grouprole: null
        }
      },
      updataroleSucEv () {
        this.$refs.roleFormex.validate(vaile => {
          if (vaile) {
            const { selectItem, group } = this
            const { role, grouprole } = group
            const params = []
            if (role.length) {
              if (!grouprole) {
                this.$message.error('请选择部门管理角色')
                return
              }
            }
            role.forEach(ids => {
              params.push({
                'coId': selectItem.decorateId,
                'id': 0,
                'isAdministration': ids === grouprole,
                'roleId': ids
              })
            })
            if (params.length === 0) {
              params.push({
                'coId': selectItem.decorateId
              })
            }
            treeAddRole(params).then(res => {
              if (isSuccess(res)) {
                this.$message.success(res.data.msg)
                this.$refs.roleFormex.resetFields()
                // this.getInit()
                this.addChildRoles(params, grouprole)
                this.closeRoleDialog()
              } else {
                this.$message.error(res.data.msg)
              }
            })
          }
        })
      },
      addChildRoles (childrenRole, adminId) {
        const { decorateId, children, id } = this.selectItem
        getCurNodeChild({ orgId: decorateId }).then(res => {
          if (isSuccess(res)) {
            const depart = children.filter(item => item.type !== 1)
            const roleArr = res.data.obj.systemRoles || []
            const newroleArr = roleArr.map(items => {
              return Object.assign(items, {
                children: [],
                decorateId: items.id,
                orgName: items.roleName,
                fatherId: decorateId,
                orgFatherId: id,
                type: 1,
                isAdministration: items.id === adminId
              })
            })
            this.selectItem.children = depart.concat(newroleArr)
          }
        })
      },
      close () {
        this.dialogVisible = false
      },
      outourse (e, data) {
        if (data.isAdministration) {
          var taget = e.target.querySelector('.power')
          if (!taget) {
          } else {
            taget.setAttribute('class', 'not_active')
          }
        }
      },
      getourse (e, data) {
        if (data.isAdministration) {
          var taget = e.target.querySelector('.not_active')
          if (!taget) {
          } else {
            taget.setAttribute('class', 'power')
          }
        }
      },
      addClass (row) {
        if (row.orgFatherId === 0) {
          return 'pather'
        } else {
          if (row.type === 0) {
            let godown = ''
            if (row.flow) {
              godown = '' // godown
            }
            if (row.isactive) {
              return 'bg-gray-active' + ' ' + godown
            } else {
              return 'bg-gray' + ' ' + godown
            }
          } else if (row.type === 1) {
            return `${
              row.isAdministration
                ? `${
                  row.isactive ? 'bg-gray-active asterisk' : 'bg-group asterisk'
                }`
                : row.isactive
                ? 'bg-gray-active'
                : 'bg-group'
            }`
          } else if (row.type === 2) {
            if (row.isactive) {
              return 'bg-gray-active'
            } else {
              return 'bg-employees'
            }
          }
        }
      },
      uphandler (row) {
        this.select_value = ''
      },
      getfilter (arr, type, id, pathIds) {
        if (type === 1) {
          type = 0
        } else if (type === 2) {
          type = 1
        }
        const t = pathIds && pathIds.split(',')
        const idex = t && Number(t[t.length - 2])
        for (const key in arr) {
          if (arr[key].type === type && arr[key].decorateId === id) {
            if (type === 1 && arr[key].orgFatherId === idex) {
              return arr[key].id
            } else if (type !== 1) {
              return arr[key].id
            }
          }
        }
      },
      handlechange (row) {
        const { selectItem } = this
        this.select_value = row
        if (isEmpty(this.selectItem)) {
          this.$message({
            message: '请先选择部门',
            type: 'error'
          })
        } else {
          if (Number(this.select_value) === 0) {
            this.dialogVisible = true
            //
            this.$nextTick(function () {
              this.groupex.name = selectItem.orgName
            })
            //
          } else {
            this.dialogVisible = false
          }
        }
      },
      updateroleS () {
        if (isEmpty(this.selectItem)) {
          this.messageInfo('请先选择部门')
        } else {
          const { children } = this.selectItem
          this.roleDialog = true
          this.$nextTick(() => {
            this.$refs.roleFormex.resetFields()
            const roles = children.filter(item => item.type === 1)
            const adminRoles = children.filter(itemes => itemes.type === 1 && itemes.isAdministration)
            this.group = Object.assign(this.group, {
              grouprole: adminRoles.map(items => items.decorateId)[0],
              role: Array.from(new Set(roles.map(item => item.decorateId)))
            })
          })
        }
      },
      updaterole (row) {
        this.optionsGroup = row
      },
      getrole () {
        getRoleList(1, 1000).then(res => {
          if (res.data.code === 200) {
            this.options = res.data.obj.records
          }
        })
      },
      toupdataStore () {
        updataStore().then(res => {
          if (isSuccess(res)) {
            this.$message.success(res.data.msg)
            this.getInit()
          } else {
            this.importStoreFail = true
            this.importStoreFlag = true
            this.tiptopTitle = res.data.msg
          }
        })
      },
      // dao入数据
      tosendimport (falg) {
        if (isEmpty(this.selectItem) && !falg) {
          this.$message({
            message: '请先选择仓储部门',
            type: 'error'
          })
          return
        } else {
          this.updataStoretxt = '更新所有仓库到仓储部？'
        }
        this.importStoreFlag = true
      },
      getparentData (data, parseId) {
        if (data.id === parseId) return data
        let res = {}
        for (let i = 0; i < data.children.length; i++) {
          if (!isEmpty(res)) {
            break
          }
          const obj = data.children[i]
          if (obj.id === parseId) {
            res = obj
            break
          } else if (obj.children && obj.children.length) {
            res = this.getparentData(obj, parseId)
          }
        }
        return res
      },
      toactive (arr, id, el) {
        var _this = this
        for (let index = 0; index < arr.length; index++) {
          const element = arr[index]
          if (element.id === id) {
            element.isactive = true
          } else {
            element.isactive = false
          }
          if (element.children) {
            _this.toactive(element.children, id)
          }
        }
      },
      toTree (list, parId) {
        var _this = this
        const len = list.length

        function loop (parId) {
          const res = []
          for (let i = 0; i < len; i++) {
            const item = list[i]
            _this.$set(item, 'isactive', false)
            if (Number(item.orgFatherId) === parId) {
              item.children = loop(item.id)
              res.push(item)
            }
            if (item.isAdministration) {

            }
          }
          return res
        }

        return loop(parId)
      },
      // 0   部门   角色1   用户
      getInit () {
        this.flowlever = 0
        getTreegroup().then(res => {
          if (res.data.code === 200) {
            // 先判断该类型是多少   如果是1和2更改id和parentID  标识当前的唯一id然后处理 数据的
            if (res.data.obj) {
              let department
              res.data.obj.forEach((res, index) => {
                let hashparams
                let groupparams
                this.$set(res, 'decorateId', res.id)
                if (res.type === 1) {
                  hashparams = res.id + new Date().getTime() + Math.random()
                  res.id = hashparams
                } else if (res.type === 2) {
                  groupparams = res.id + new Date().getTime() + Math.random()
                  res.id = groupparams
                } else if (res.type === 0) {
                  if (index !== 0) {
                    department = res.id + new Date().getTime() + Math.random()
                    res.id = department
                  }
                }
                //
              })
              const temarrlist = deepClone(res.data.obj)
              res.data.obj.forEach((item, index) => {
                if (
                  item.orgFatherId === 0
                  // temarrlist[index].orgFatherId === 1
                ) {

                } else {
                  const ids = this.getfilter(
                    temarrlist,
                    item.type,
                    item.orgFatherId,
                    item.orgFatherPathIds
                  )
                  item.fatherId = item.orgFatherId
                  item.orgFatherId = ids
                }
              })
              this.data = this.toTree(res.data.obj, 0)[0]
              this.toggleExpand(this.data, true)
              this.groupDepartment() //用来对部门和角色分层
            }
          }
        })
      },
      groupDepartment () {
        const { data } = this
        const clonedata = [deepClone(data)]
        this.addDataProps(clonedata)
        this.data = clonedata[0]
        this.loading = false
      },
      addDataProps (data) {
        data.forEach(item => {
          const itemchild = item.children
          if (item.orgName === '仓储部' && itemchild && itemchild.length) {
            this.updataStroe = false
          }
          if (itemchild && itemchild.length) {
            const type0 = itemchild.every(childitem => childitem.type === 0) // 部门
            const type1 = itemchild.every(childitem => childitem.type === 1) // 角色
            const type2 = itemchild.every(childitem => childitem.type === 2) // 用户
            if (type0 || type1 || type2) {
              itemchild.forEach(itemex => itemex.flow = false)
            } else {
              itemchild.forEach(itemee => {
                if (itemee.type === 0) {
                  itemee.flow = true // 只有部门需要向下一级
                } else {
                  itemee.flow = false
                }
              })
            }
            this.addDataProps(itemchild)
          }
        })
      },
      addgroup () {
        this.istatus = 0
        if (!this.isStatusCreateGroupOneEnable) {
          if (!isEmpty(this.data.children)) {
            if (isEmpty(this.selectItem)) {
              this.messageInfo('请先点击对应的部门')
              return false
            }
          }
        }
        this.title = '创建部门'
        this.dialogVisible = true
        this.groupex.name = ''
      },

      submitCheck () {
        const { selectItem, isStatusCreateGroupOneEnable, groupex, istatus, data } = this
        this.$refs.group.validate(vail => {
          if (vail) {
            if (!isEmpty(selectItem) && istatus === 1) {
              // 编辑部门
              updategroupname(Object.assign(deepClone(selectItem), {
                orgName: groupex.name,
                orgFatherId: selectItem.fatherId,
                id: selectItem.decorateId // 后台不用这个id
              })).then(res => {

                if (isSuccess(res)) {
                  this.$message.success('添加成功')
                  this.dialogVisible = false
                  Object.assign(this.selectItem, {
                    orgName: groupex.name
                  })
                  // this.getInit()
                  this.groupex.name = ''
                } else {
                  this.$message.error(res.data.msg)
                }
              })
              return
            }
            let params = {}
            if (isStatusCreateGroupOneEnable) {
              // 添加公司部门
              params = Object.assign(deepClone(data), {
                orgName: groupex.name,
                orgFatherId: 1
              })
              this.selectItem = this.data
            } else {
              params = Object.assign(deepClone(selectItem), {
                orgName: groupex.name,
                orgFatherId: selectItem.decorateId,
                id: selectItem.decorateId
              })
            }
            // 添加子部门
            getAddgroupItem(params).then(res => {
              if (isSuccess(res)) {
                this.$message.success('添加成功')
                this.dialogVisible = false
                this.selectItem.expand = true
                this.selectItem.children.unshift(Object.assign(deepClone(selectItem), {
                  ...res.data.obj,
                  decorateId: res.data.obj.id,
                  children: [],
                  isactive: false,
                  type: 0,
                  fatherId: res.data.obj.orgFatherId,
                  orgFatherId: selectItem.id
                }))
                this.groupex.name = ''
              } else {
                this.$message.error(res.data.msg)
              }
            })
          }
        })
      },
      messageInfo (title, type = 'error') {
        this.$message[type](title)
      },

      renderContent (h, data) {
        if (data.isAdministration && data.type !== 2) {
          // 这里是架构图集成了jsx的支持，但是编辑器会报错，不用管，程序能正常跑的
          /*
           *  由于这是jsx的原因，代码格式化会把代码格式化出问题，如果这里被格式化乱了就需要复制下面代码
           * <span>
           <el-tooltip class="item" effect="dark" content={name} placement="top-start">
           <span> {data.orgName}</span>
           </el-tooltip>
           </span>
           */
          const fatherobj = this.loopFatherDatawx([this.data], data.orgFatherId)
          const name = `${fatherobj.orgName}管理角色`
          return (
            <span>
            <el-tooltip class="item" effect="dark" content={name} placement="top-start">
            <span> {data.orgName}</span>
            </el-tooltip>
            </span>
          )
        }
        return data.orgName
      },
      loopFatherDatawx (data, fatherid) {
        let a = {}
        data.forEach(item => {
          if (item.id === fatherid) {
            a = item
          }
          if (item.children && item.children) {
            const b = this.loopFatherDatawx(item.children, fatherid)
            a = b ? b : a
          }
        })
        return isEmpty(a) ? false : a
      },
      onExpand (e, data) {
        if ('expand' in data) {
          data.expand = !data.expand
          if (!data.expand && data.children) {
            this.collapse(data.children)
          }
        } else {
          this.$set(data, 'expand', true)
        }
      },
      onNodeClick (e, data) {
        e.stopPropagation()
        if (data.type !== 0) return
        this.isStatusCreateGroupOneEnable = data.orgFatherId == 0
        this.toactive([this.data], data.id, e)
        this.selectItem = data
        this.isshow = data.orgName === '仓储部'
        if (this.isshow) {
          this.storeFalg = Boolean(data.children && data.children.length)
        }
        this.storeDiaabled = this.selectItem.orgType === 2
        const orgFatherPath = data.orgFatherPath.split('>')
        this.creatdepartdisabled = orgFatherPath.length > 5
        this.findCurItemFatherData()
      },
      findCurItemFatherData () {
        const { selectItem, data } = this
        const fatherids = selectItem.orgFatherId
        const ars = [data]
        this.loopFatherData(ars, fatherids)
      },
      loopFatherData (data, fatherid) {
        data.forEach(item => {
          if (item.id === fatherid) {
            this.fatherItem = item
          }
          if (item.children && item.children) {
            this.loopFatherData(item.children, fatherid)
          }
        })
      },
      collapse (list) {
        list.forEach(function (child) {
          if (child.expand) {
            child.expand = false
          }
          child.children && _this.collapse(child.children)
        })
      },
      toggleExpand (data, val) {
        this.flowlever = this.flowlever + 1
        if (this.flowlever > this.preflowlever) {
          val = false
        }
        if (Array.isArray(data)) {
          data.forEach(function (item) {
            _this.$set(item, 'expand', val)
            if (item.children) {
              _this.toggleExpand(item.children, val)
            }
          })
        } else if (data) {
          this.$set(data, 'expand', val)
          if (data.children) {
            _this.toggleExpand(data.children, val)
          }
        }
      }
    }
  }
</script>
<style
  lang="less"
  scoped>
  /deep/ .org-tree-node-label-inner .pather {
    overflow: hidden !important;
  }

  .font_btn {
    color: #4e555b;
    font-size: 14px;
  }

  /deep/ .org-tree-node-btn {
    width: 14px;
    height: 14px;
    margin-left: -7px;
    top: 110%;
  }

  /deep/ .org-tree-node-btn:before {
    border-top: 1px solid #a9c5ff;
    border: 0;
    content: '+';
    position: absolute;
    left: 0px;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 99;
    color: #a9c5ff;
    text-align: center;
    line-height: 12px;
  }

  /deep/ .org-tree-node-btn:after {
    border-left: 1px solid #a9c5ff;
    border: 0;
  }

  /deep/ .org-tree-node-btn.expanded:before {
    border-top: 1px solid #a9c5ff;
    border: 0;
    content: '-';
    position: absolute;
    left: 0px;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 99;
    color: #a9c5ff;
    text-align: center;
    line-height: 12px;
  }

  /deep/ .org-tree-node-btn.expanded:after {
    border-left: 1px solid #a9c5ff;
    border: 0;
  }

  /deep/ .org-tree-node-btn {
    border: 1px solid #a9c5ff;
  }

  /deep/ .box_content {
    height: 19px;
    position: absolute;
    background: #276cff;
    z-index: 2222;
    top: 50%;
    margin-top: -2.1rem;
    left: 50%;
    width: 13px;
  }

  /deep/ .org-tree-node:not(:first-child):before,
  .org-tree-node:not(:last-child):after {
    border-top: 1px solid #a9c5ff;
  }

  /deep/ .org-tree-node:after:last-child {
    border-left: none;
  }

  /deep/ .org-tree-node:not(:first-child):before,
  .org-tree-node:not(:last-child):after {
    border-top: 1px solid #a9c5ff !important;
  }

  /deep/ .org-tree-node-children:before {
    border-left: 1px solid #a9c5ff;
  }

  /deep/ .org-tree-node:not(:last-child):after {
    border-top: 1px solid #a9c5ff !important;
  }

  /deep/ .org-tree-node:not(:first-child):before,
  .org-tree-node:not(:last-child):after {
    border-top: 1px solid #a9c5ff;
  }

  /deep/ .org-tree-node:after {
    border-left: 1px solid #a9c5ff;
  }

  /deep/ .org-tree {
    position: relative;
    margin: 0px auto;
  }

  /deep/ .pather {
    background: #276cff;
    border-radius: 4px;
    font-size: 20px;
    color: #ffffff;
    padding: 15px;
    box-sizing: border-box;
    overflow: hidden;
    // margin: 0px auto;
  }

  /deep/ .bg-group {
    border: 1px dashed rgba(81, 137, 255, 1);
    box-shadow: none;
    background: rgba(81, 137, 255, 0.2);
    padding: 9px 14px;
    cursor: default;
  }

  /deep/ .bg-group:hover {
    background: rgba(81, 137, 255, 0.4);
  }

  /deep/ .bg-employees {
    color: #4e555b;
    font-size: 14px;
    border: none;
    box-shadow: none;
  }

  /deep/ .asterisk {
    position: relative;
  }

  /deep/ .asterisk::before {
    margin-left: -7px;

    content: '*';
    color: red;
    position: absolute;
    // margin-bottom: -9px;
    display: block;
  }

  /deep/ .parent-power {
    //  padding: 10px;
    position: relative;
  }

  /deep/ .not_active {
    display: none;
  }

  /deep/ .power {
    top: -27px;
    // left: 12px;
    left: -40px;
    width: 122px;
    height: 30px;
    line-height: 30px;
    /* width: 100%; */
    position: absolute;
    display: block;
    background-color: #000000;
    opacity: 0.75;
    color: #fff;
    z-index: 2;
    border-radius: 5px;
  }

  /deep/ .el-main {
    width: 100vw;
    background-color: #ffff;
  }

  .container {
    overflow: auto;
  }

  /deep/ .active {
    padding: 10px 15px;
    // color: red;

    color: #d35e5e;
    font-size: 14px;
    background: #f3f7ff;
    border-radius: 4px;
    border: 1px dotted #afc5ff;
  }

  .not-select {
    color: blue;
  }

  .border_content {
    margin-bottom: 2px;
  }

  .contwent {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .default {
    background-color: #ffff;
    color: rgba(78, 85, 91, 1);
  }

  .addgroup {
    background: rgba(39, 108, 255, 0.04);
    font-size: 14px;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 400;
    color: #276cff;
  }

  .org-tree-container {
    width: 100%;
  }

  .org-tree-node-label {
    white-space: nowrap;
  }

  .text-center {
    background-color: white;
    overflow: hidden;
    width: 100%;
    position: relative;
    padding: 20px;
    border-radius: 10px;
    box-sizing: border-box;
  }

  .top_header {
    position: absolute;
    left: 0;
    top: 0;
    padding: 20px;
    box-sizing: border-box;
  }

  .bg-white {
    background-color: white;
  }

  .bg-orange {
    background-color: orange;
  }

  .bg-gold {
    background-color: gold;
  }

  /deep/ .bg-gray {
    padding: 10px 15px;
    background: rgba(39, 108, 255, 0.8);
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 400;
    color: #fff;
    box-shadow: none;
  }

  /deep/ .bg-gray-active {
    padding: 10px 15px;
    background: rgba(39, 108, 255, 1);
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 400;
    color: #fff;
    box-shadow: none;
  }

  /deep/ .org-tree-node-label {
  }

  .bg-lightpink {
    background-color: lightpink;
  }

  .bg-chocolate {
    background-color: chocolate;
  }

  .bg-tomato {
    background-color: tomato;
  }

  /deep/ .org-tree-node-label .org-tree-node-label-inner {
    white-space: nowrap;
  }

  /deep/ .org-tree-node-children {
    padding-top: 40px !important;
    margin: 0 auto;
  }

  /deep/ .org-tree-node-children:after {
    position: absolute;
    width: 1px;
    height: 20px;
    left: 50%;
    top: 20px;
    background: #a9c5ff;
  }

  /deep/ .godown {
    margin-top: 100px !important;
    position: relative;
  }

  /deep/ .godown::before {
    content: "";
    position: absolute;
    left: 50%;
    top: -100px;
    width: 1px;
    height: 100px;
    margin-left: 0px;
    background: #afc5ff;
  }
</style>
<style>
  #tree-el {
    /*transition: all .5s linear;*/
    /*user-select: none !important;*/
    /*transform: scale(0.3) translateX(-200%);*/
  }

  .font_btn input::placeholder {
    color: #606266;
  }

  #tree-el > .org-tree > .org-tree-node::after {
    display: none;
  }

  .el-select-dropdown.el-popper.optionsContent ul li {
    font-size: 12px !important;
  }
</style>
